import cx from 'classnames';
import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import style from './button.module.css';

export interface ButtonProps extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
    className?: string;
    danger?: boolean;
    fullWidth?: boolean;
    priority?: 'primary' | 'secondary';
}

const Button = ({
    children,
    className,
    danger,
    fullWidth,
    priority = 'primary',
    ...props
}: ButtonProps) => (
    <button
        className={cx(className, style.button, {
            [style.fullWidth]: fullWidth,
            [style.danger]: danger,
            [style.secondary]: priority === 'secondary',
        })}
        {...props}
    >
        {children}
    </button>
);

export default Button;
